
import { PackageTier, UpgradeItemType, UpgradePricingResponseDto } from 'fourwaves-shared';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { TranslateResult } from 'vue-i18n';

@Component({})
export default class CheckoutPlanTile extends Vue {
  @Prop({ type: Object, required: true }) readonly plan!: UpgradePricingResponseDto;
  @Prop(Boolean) readonly currentPlan!: boolean;
  @Prop({ type: Boolean, default: true }) readonly hasPayingPlan!: boolean;

  readonly UpgradeItemType = UpgradeItemType;

  get name(): TranslateResult {
    return this.currentPlan ? this.$t('plans.tile.current_plan') : this.$t('plans.tile.new_plan');
  }

  get cost(): string | TranslateResult {
    return this.hasPayingPlan
      ? this.formatMoney(this.plan.subtotalBeforeCredit, this.plan.currency)
      : this.$t('plans.tile.free');
  }

  get subtotalBeforeRebates(): string {
    if (this.currentPlan) return '';
    return this.plan.subtotalBeforeRebates > this.plan.subtotalBeforeCredit
      ? this.formatMoney(this.plan.subtotalBeforeRebates, this.plan.currency)
      : '';
  }

  get hasMultiYearDiscount(): boolean {
    if (this.currentPlan) return false;
    return this.plan.items.some(({ type }) => type === UpgradeItemType.MultiYearDiscount);
  }

  get hasMultiEventDiscount(): boolean {
    if (this.currentPlan) return false;
    return this.plan.items.some(({ type }) => type === UpgradeItemType.MultiEventDiscount);
  }

  get tier(): TranslateResult {
    const tierItem = this.plan.items.find(({ packageTier }) => packageTier);
    return tierItem
      ? this.$t(`plans.package_name.${tierItem.packageTier}`)
      : this.$t(`plans.package_name.${PackageTier.Free}`);
  }

  get term(): string {
    const userTimezone = this.$moment.tz.guess(true);
    const startMoment = this.$moment(this.plan.planStartDate).tz(userTimezone);
    const endMoment = this.$moment(this.plan.planEndDate).tz(userTimezone);
    const fromTo = `${startMoment.format('LL')} - ${endMoment.format('LL')}`;
    return `${this.$tc('plans.year', this.plan.termLengthInYears)}  (${fromTo})`;
  }

  get addons(): string | TranslateResult {
    const addonItems = this.plan.items.filter(({ addOnType }) => addOnType);
    return addonItems.length
      ? addonItems.map(({ addOnType }) => this.$t(`plans.addon_name.${addOnType}`)).join(', ')
      : this.$t('plans.tile.none');
  }
}
